import { format } from 'date-fns'

const dateOnly = /^\d{4}-\d{2}-\d{2}$/

export const formatDate = (value: number | string): string =>
  value
    ? format(new Date(typeof value === 'string' && dateOnly.test(value) ? `${value}T00:00:00` : value), 'dd/MM/yyyy')
    : '-'
